/**
 * FaceSwap 选项配置 - 国际化版本
 * 使用翻译键引用，支持多语言
 */
import CameraOptions from './CameraOptions.js';
import RoleOptions from './RoleOptions.js';
import StyleOptions from './StyleOptions.js';
import EnvOptions from './EnvOptions.js';


export const options = [
  ...RoleOptions,
  ...CameraOptions,
  ...StyleOptions,
  ...EnvOptions,
];